import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../../contexts/AuthContext';
import lavenderIconLight from '../../assets/blue_unfilled_icon_light.png';
import lavenderIconDark from '../../assets/lavender_unfilled_icon_dark.png';

const API_URL = '/api';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, darkMode } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/admin/login`, { username, password });
      // Extract CSRF token from response header
      const csrfToken = response.headers['x-csrf-token'];
      login(response.data.user, csrfToken);
      navigate('/admin');
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'An error occurred';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-logo">
          <h1>
            <img src={darkMode ? lavenderIconDark : lavenderIconLight} alt="Ref-Lex Icon" style={{ height: '3em', verticalAlign: 'bottom', marginRight: '0.3em' }} />
            <span className="logo-text">Ref-Lex</span>
          </h1>
          <p className="tagline">Another Reference Manager</p>
        </div>
        <h2>Admin Login</h2>
        {error && <div className="error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            disabled={loading}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Admin Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
